// Lock browser gesture zoom for the app shell, while keeping scroll and Leaflet map interaction.
export function installAppViewport(){
 const prevent=(event:Event)=>{if(event.cancelable)event.preventDefault();};
 const touch=(event:TouchEvent)=>{if(event.touches.length>1&&!(event.target instanceof Element&&event.target.closest(".leaflet-container")))prevent(event);};
 const wheel=(event:WheelEvent)=>{if(event.ctrlKey)prevent(event);};
 document.addEventListener("gesturestart",prevent,{passive:false});
 document.addEventListener("gesturechange",prevent,{passive:false});
 document.addEventListener("touchstart",touch,{passive:false});
 document.addEventListener("touchmove",touch,{passive:false});
 document.addEventListener("wheel",wheel,{passive:false});
 return()=>{document.removeEventListener("gesturestart",prevent);document.removeEventListener("gesturechange",prevent);document.removeEventListener("touchstart",touch);document.removeEventListener("touchmove",touch);document.removeEventListener("wheel",wheel);};
}
